import cn from 'classnames';
import { ColumnProps } from 'antd/lib/table';
import { Icon, Tag } from 'Components';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';
import styles from './GroupSummaryTable.module.scss';
import { TFunction } from 'i18next';
import { STATUS_COLOR } from 'Pages/Dashboard/Dashboard.constants';

const sortableTitle = (label: string) => (
	<span className={styles.colTitle}>
		<span>{label}</span>
		<Icon
			type="chevronDown"
			className={`${styles.colSortIcon} group-table-sort-icon`}
		/>
	</span>
);

export const renderScoreCell = (value: number | undefined | null) => {
	if (value == null) return '—';
	const isGood = value >= 50;
	return (
		<span className={styles.scoreCell}>
			<span
				className={cn(
					styles.dot,
					isGood ? styles.dotBlue : styles.dotOrange
				)}
			/>
			{`${Math.round(value)}%`}
		</span>
	);
};

export const renderTagCell = (value: string | undefined, t: TFunction) => {
	if (!value) return '---';
	const tag = value === "pass" ? "Compliant" : value === "fail" ? "Non-Compliant" : value === "incomplete" ? "Incomplete" : "Not Started";
	const { color, background } = STATUS_COLOR[tag] || STATUS_COLOR["Not Started"];
	const tagValue =  t(`newDashboard.summaryTable.tags.${tag}`);
	return <Tag style={{ background, color }}>{tag || ""}</Tag>
};

export function getGroupSummaryColumns(t: TFunction): ColumnProps<OverviewGroupSummary>[] {
	return [
		{
			title: sortableTitle(t('newDashboard.summaryTable.headers.summary')),
			key: 'groupName',
			dataIndex: 'groupName',
			sorter: true
		},
		{
			title: sortableTitle(t('newDashboard.summaryTable.headers.phishing')),
			key: 'phishingScore',
			dataIndex: 'phishingScore',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: sortableTitle(t('newDashboard.summaryTable.headers.training')),
			key: 'elearningScore',
			dataIndex: 'elearningScore',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: t('newDashboard.summaryTable.headers.saqCompliance'),
			key: 'saqStatus',
			dataIndex: 'saqStatus',
			align: "center",
			render: (value) => renderTagCell(value, t)
		},
		{
			title: t('newDashboard.summaryTable.headers.scanning'),
			key: 'scanningStatus',
			dataIndex: 'scanningStatus',
			align: "center",
			render: (value) => renderTagCell(value, t)
		}
	];
}
